// src/auth/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { login as wsLogin, refreshToken, setAuthToken } from "../api/wsApi";

const admins = ["heboba", "admin"];
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setLoading] = useState(true);

  //Here check if user is already logged in
  useEffect(() => {
    const savedUser = localStorage.getItem('token');

    if (savedUser) {
      const userData = JSON.parse(savedUser);
      if (userData.expires > Date.now()) {
        setUser(userData);
        setAuthToken(userData.accessToken);

        // Refresh token if it expires in less then 4 days
        if (userData.expires - Date.now() < 4 * 24 * 60 * 60 * 1000) {
          // Refresh token
          console.log('Refresh token');
          refreshToken(userData.accessToken)
            .then((data) => {
              const newUserData = { name: userData.name, accessToken: data.accessToken, expires: Date.now() + 7 * 24 * 60 * 60 * 1000 }; // 7 days
              localStorage.setItem('token', JSON.stringify(newUserData));
              setUser(newUserData);
              setAuthToken(data.accessToken);
            })
            .catch((err) => {
              alert('Error refreshing token: ' + err);
            });
        }
      } else {
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      // Функция для проверки аутентификации
      checkAuthStatus();
    }, 300000); // Проверка каждые 5 минут

    // Функция для очистки интервала
    return () => clearInterval(interval);
  }, []);

  const checkAuthStatus = () => {
    if (user) {
      if (user.expires < Date.now()) {
        logout();
      }
    }
  }



  const login = async (username, password) => {
    const data = await wsLogin(username, password);

    const userData = { name: username, accessToken: data.accessToken, expires: Date.now() + 7 * 24 * 60 * 60 * 1000 }; // 7 days
    localStorage.setItem('token', JSON.stringify(userData));
    setUser(userData);
    setAuthToken(data.accessToken);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    setAuthToken(null);
  };

  const isAdmin = useCallback(() => {
    return user && admins.includes(user.name);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
